import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'

export const useBasketTotalItems = () => {
    const {data: basket} = useCurrentBasket()

    const allSubscriptionsDetails = basket?.c_allSubscriptionsDetails
        ? JSON.parse(basket.c_allSubscriptionsDetails)
        : {}

    const totalItems =
        (basket?.productItems
            ?.filter((item) => item.c_isSubscription !== true && item.c_isSubscription !== 'true')
            ?.reduce((acc, item) => acc + item.quantity, 0) || 0) +
        Object.keys(allSubscriptionsDetails).length
    return totalItems
}
